export type ToneName = 'primary' | 'accent' | 'secondary' | 'foreground';

export interface ToneClasses {
  text: string;
  softBg: string;
  softText: string;
  border: string;
  solidBg: string;
  solidText: string;
  rule: string;
}

export const toneMap: Record<ToneName, ToneClasses> = {
  primary: {
    text: 'text-primary-700',
    softBg: 'bg-primary-100',
    softText: 'text-primary-800',
    border: 'border-primary-300',
    solidBg: 'bg-primary-500',
    solidText: 'text-background-50',
    rule: 'bg-primary-500',
  },
  accent: {
    text: 'text-accent-700',
    softBg: 'bg-accent-100',
    softText: 'text-accent-900',
    border: 'border-accent-300',
    solidBg: 'bg-accent-500',
    solidText: 'text-accent-950',
    rule: 'bg-accent-500',
  },
  secondary: {
    text: 'text-secondary-700',
    softBg: 'bg-secondary-100',
    softText: 'text-secondary-900',
    border: 'border-secondary-300',
    solidBg: 'bg-secondary-500',
    solidText: 'text-background-50',
    rule: 'bg-secondary-500',
  },
  foreground: {
    text: 'text-foreground-700',
    softBg: 'bg-foreground-100',
    softText: 'text-foreground-900',
    border: 'border-foreground-300',
    solidBg: 'bg-foreground-800',
    solidText: 'text-background-50',
    rule: 'bg-foreground-800',
  },
};

export function getTone(tone: string): ToneClasses {
  return toneMap[tone as ToneName] ?? toneMap.foreground;
}